<template>
  <div class="fromComm">
    <div style="display: flex;flex-wrap: wrap;align-content: flex-start;">
      <div :style="[ {marginLeft: `${ FromUploadSetting.marginLeft }px`},{marginTop: `${ FromUploadSetting.marginTop }px`} ]" style="margin-left: 20px;">
        <!-- 上传 -->
        <template v-if="FromUploadSetting.inputtype == `upload`">
          <form style="display: inline-block" v-if="`${ FromUploadSetting.inputflag }`" class="dateSection">
            <div :style="[{fontSize: `${ FromUploadSetting.fontSize }px` },{ color: `${ FromUploadSetting.color }` },{ height: `${  FromUploadSetting.lableheight }px` },{ width: `${  FromUploadSetting.lablewidth }px` },{display: `${  FromUploadSetting.displayVal }`} , {fontWeight:  `${  FromUploadSetting.fontWeightVal }`}]" style=" font-weight: 500;">
              <slot></slot>
              {{  FromUploadSetting.title }}
              <span style="color: #E71D43;  position: relative;top: 2px;" v-if="FromUploadSetting.X">*</span>
            </div>
            <div @click="uploadClick" class="upload" :style="[{ width: `${ FromUploadSetting.width }px` },{ height: `${ FromUploadSetting.height }px` },{color: `${  FromUploadSetting.uploadColor }`},{ fontSize: `${  FromUploadSetting.fontSize }px` },{backgroundColor: `${  FromUploadSetting.backgroundColor }`}]">
              {{  FromUploadSetting.uploadTitle }}
            </div>
          </form>
        </template>
      </div>
    </div>
    <input ref="filElem" id="filElem" :accept=" FromUploadSetting.accept" type="file" multiple="multiple" class="upload-file" @change="getFiles" style="display: none;" v-if="FromUploadSetting.multiple">
    <input ref="filElem" id="filElem" :accept=" FromUploadSetting.accept" type="file" class="upload-file" @change="getFile" style="display: none;" v-if="!FromUploadSetting.multiple">
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // 文本框
    FromUpload: {
      type: Array
    },
    FromUploadSetting: {
      type: Object
    }
  },
  data() {
    return {
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    uploadClick() {
      this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
    },
    getFile(e) {
        const inputFile = e.target.files[0];
      this.$emit('getFile', inputFile)
      // input[file]标签防重复问题
      e.target.value = ""
    },
    getFiles(e) {
      const inputFile = e.target.files;
      console.log('进来了----------');
      console.log(inputFile, 'inputFile');
      this.$emit('getFiles', inputFile)
      // input[file]标签防重复问题
      e.target.value = ""

    },
  },
  computed: {

  },
  watch: {

  },
}
</script>
<style scoped lang='less'>
.fromComm {
  user-select: none;
}
.upload {
  display: inline-block;
  user-select: none;
  text-align: center;
  line-height: 32px;
  border-radius: 2px;
  border: 1px solid #e6e6e6;
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;
}
</style>